module.exports = __webpack_public_path__ + "cb5e04c23adb85020f9b481115f8ded0.jpg";